import Persistable from "../../../storage/persistable";

/**
 * Abstract base for game clocks. Subclasses MUST implement every method.
 * All clocks share this contract regardless of whether they tick (GameClock)
 * or stay frozen until manually changed (ManualGameClock).
 */
export default class Clock extends Persistable {
    /** Current effective game time in milliseconds. */
    // eslint-disable-next-line class-methods-use-this
    now() {
        throw new Error("Clock.now() not implemented");
    }

    /** Initialize the clock (start ticking if applicable). */
    // eslint-disable-next-line class-methods-use-this
    start() {
        throw new Error("Clock.start() not implemented");
    }

    /** Freeze the clock value. */
    // eslint-disable-next-line class-methods-use-this
    pause() {
        throw new Error("Clock.pause() not implemented");
    }

    /** Resume ticking from the current value (no-op for static clocks). */
    // eslint-disable-next-line class-methods-use-this
    continue() {
        throw new Error("Clock.continue() not implemented");
    }

    /** True if clock is not advancing. */
    // eslint-disable-next-line class-methods-use-this
    isPaused() {
        throw new Error("Clock.isPaused() not implemented");
    }

    /** Reset to initial state. */
    // eslint-disable-next-line class-methods-use-this
    reset() {
        throw new Error("Clock.reset() not implemented");
    }

    /** Set the current value in seconds. */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    setSeconds(seconds) {
        throw new Error("Clock.setSeconds() not implemented");
    }

    /** Adjust the current value by N seconds. */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    addSeconds(seconds) {
        throw new Error("Clock.addSeconds() not implemented");
    }

    /** Time elapsed since the clock started. */
    // eslint-disable-next-line class-methods-use-this
    getElapsedTime() {
        throw new Error("Clock.getElapsedTime() not implemented");
    }

    /** Time remaining until the limit. */
    // eslint-disable-next-line class-methods-use-this
    getRemainingTime() {
        throw new Error("Clock.getRemainingTime() not implemented");
    }
}
